// extracted by mini-css-extract-plugin
export default {"navLinks":"NavigationLinks_navLinks__Bxu5l","navLink":"NavigationLinks_navLink__+9NRi"};